<template>
  <v-app class="bg-white">
    <v-overlay :value="loader">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-main class="auth-pages modern-card-layout" v-if="company" >


          <!-- Fixed Bottom Footer Navigation -->
          <div class="footer-nav" :style="getStyle('footer')">
            <div class="footer-nav-container">
              <div class="footer-nav-item" @click="addCard()">
                <i aria-hidden="true" class="material-icons-round footer-icon" :style="vcard.header_color=='Light Text' ? 'color:black!important' : 'color:white!important'">contact_page</i>
                <span class="footer-label" :style="vcard.header_color=='Light Text' ? 'color:black!important' : 'color:white!important'">Card</span>
              </div>

              <div class="footer-nav-item" @click.stop="overlay = !overlay">
                <i aria-hidden="true" class="material-icons-round footer-icon" :style="vcard.header_color=='Light Text' ? 'color:black!important' : 'color:white!important'">qr_code_2</i>
                <span class="footer-label" :style="vcard.header_color=='Light Text' ? 'color:black!important' : 'color:white!important'">Scan</span>
              </div>

              <div class="footer-nav-item" @click="$router.push('/reviews')">
                <i aria-hidden="true" class="material-icons-round footer-icon" :style="vcard.header_color=='Light Text' ? 'color:black!important' : 'color:white!important'">reviews</i>
                <span class="footer-label" :style="vcard.header_color=='Light Text' ? 'color:black!important' : 'color:white!important'">Reviews</span>
              </div>

              <div class="footer-nav-item" @click="callNumber(company.phone_m)">
                <i aria-hidden="true" class="material-icons-round footer-icon" :style="vcard.header_color=='Light Text' ? 'color:black!important' : 'color:white!important'">call</i>
                <span class="footer-label" :style="vcard.header_color=='Light Text' ? 'color:black!important' : 'color:white!important'">Call</span>
              </div>
            </div>
          </div>
          <!-- Modern Profile Card Section -->
          <div class="profile-card-section" :style="getStyle('background')">
            <!-- Floating Action Buttons -->
            <v-fab-transition>
              <v-btn
                color="rgba(255,255,255,0.2)"
                fab
                small
                dark
                top
                @click="$router.push('/login')"
                left
                absolute
                class="floating-action-btn"
                style="top: 20px; left: 20px;"
              >
                <i class="material-icons-round">login</i>
              </v-btn>
            </v-fab-transition>

            <v-fab-transition>
              <v-btn
                color="rgba(255,255,255,0.2)"
                fab
                small
                dark
                top
                @click="shareLink"
                right
                absolute
                class="floating-action-btn"
                style="top: 20px; right: 20px;"
              >
                <i class="material-icons-round">share</i>
              </v-btn>
            </v-fab-transition>

            <!-- Profile Image -->
            <div class="profile-image-container">
              <img
                :src="base_url_img+company.avatar"
                class="profile-image"
                alt="Profile Photo"
              >
            </div>

            <!-- Name and Title -->
            <div class="profile-info">
              <h1 class="profile-name" :style="vcard.header_color=='Light Text' ? 'color:#000000!important' : 'color:#FFFFFF!important'">
                {{company.first_name}} {{company.last_name}}
              </h1>
              <p class="profile-title" :style="vcard.header_color=='Light Text' ? 'color:#000000!important' : 'color:#FFFFFF!important'">
                {{getPreferredRoleDescription()}}
              </p>
            </div>

            <!-- Join the Program Button -->
            <div class="join-program-container">
              <!-- Direct button for Referring Agent (no dropdown) -->
              <v-btn
                v-if="isReferringRep()"
                rounded
                x-large
                block
                elevation="0"
                class="join-program-btn"
                :style="getJoinButtonStyle()"
                @click="becomeAgent('referring')"
              >
                <span class="btn-text">Become a Referring Agent</span>
              </v-btn>

              <!-- Dropdown menu for Sales Agent -->
              <v-menu v-else offset-y top :close-on-content-click="true">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    rounded
                    x-large
                    block
                    elevation="0"
                    class="join-program-btn"
                    :style="getJoinButtonStyle()"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <span class="btn-text">Join the Program</span>
                  </v-btn>
                </template>
                <v-list class="program-dropdown-list">
                  <!-- Program options -->
                  <v-list-item
                    v-for="program in programs"
                    :key="program"
                    @click="selectProgram(program)"
                    class="program-list-item"
                  >
                    <v-list-item-title class="program-item-text">{{ program }}</v-list-item-title>
                  </v-list-item>
                  <!-- Divider -->
                  <v-divider class="my-1"></v-divider>
                  <!-- Become a Referring Agent -->
                  <v-list-item
                    @click="becomeAgent('referring')"
                    class="program-list-item"
                  >
                    <v-list-item-title class="program-item-text">
                      Become a Referring Agent
                    </v-list-item-title>
                  </v-list-item>
                  <!-- Become a Sales Agent -->
                  <v-list-item
                    @click="becomeAgent('sales')"
                    class="program-list-item"
                  >
                    <v-list-item-title class="program-item-text">
                      Become a Sales Agent
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>

            <!-- Exchange Contact Button -->
            <div class="exchange-contact-container">
              <v-btn
                rounded
                large
                block
                outlined
                elevation="0"
                class="exchange-contact-btn"
                :style="getExchangeButtonStyle()"
                @click="showExchangeContactModal = true"
              >
                <v-icon left small class="material-icons-round">swap_horiz</v-icon>
                <span class="btn-text">Exchange Contact</span>
              </v-btn>
            </div>

            <!-- Send Message Button -->
            <div class="send-message-container">
              <v-btn
                rounded
                large
                block
                elevation="0"
                color="green"
                dark
                class="send-message-btn"
                @click="showChatPopup = true"
              >
                <v-icon left small class="material-icons-round">chat</v-icon>
                <span class="btn-text">Send Message</span>
              </v-btn>
            </div>

            <!-- View Inventory Button -->
            <div class="view-inventory-container">
              <v-btn
                rounded
                large
                block
                elevation="0"
                color="#1976D2"
                dark
                class="view-inventory-btn"
                @click="handleViewInventory"
              >
                <v-icon left small class="material-icons-round">directions_car</v-icon>
                <span class="btn-text">View Inventory</span>
              </v-btn>
            </div>

            <!-- Action Icons Row -->
            <div class="action-icons-row">
              <div class="action-icon-item" @click="callNumber(company.phone_m)">
                <div class="action-icon-circle" :style="getActionIconStyle()">
                  <i class="material-icons-round" :style="vcard.header_color=='Light Text' ? 'color:#000000!important' : 'color:#FFFFFF!important'">call</i>
                </div>
              </div>

              <div class="action-icon-item" @click="sendEmail(company.email)">
                <div class="action-icon-circle" :style="getActionIconStyle()">
                  <i class="material-icons-round" :style="vcard.header_color=='Light Text' ? 'color:#000000!important' : 'color:#FFFFFF!important'">email</i>
                </div>
              </div>

              <div class="action-icon-item" style="position: relative;">
                <div class="action-icon-circle" :style="getActionIconStyle()" @click="toggleSocialDial">
                  <i class="material-icons-round" :style="vcard.header_color=='Light Text' ? 'color:#000000!important' : 'color:#FFFFFF!important'">link</i>
                </div>
              </div>
            </div>

            <!-- Social Media Speed Dial (Floating Above) -->
            <div v-if="socialSpeedDial" class="social-speed-dial-overlay">
              <div class="social-buttons-container">
                <!-- Close Button -->
                <div class="social-icon-item" @click="toggleSocialDial">
                  <div class="social-icon-circle" style="background: #666666;">
                    <i class="material-icons-round" style="color: #FFFFFF;">close</i>
                  </div>
                </div>

                <!-- YouTube -->
                <div v-if="company.youtube" class="social-icon-item" @click="openSocialLink(company.youtube, 'youtube')">
                  <div class="social-icon-circle" style="background: #FF0000;">
                    <i class="fab fa-youtube" style="color: #FFFFFF; font-size: 30px;"></i>
                  </div>
                </div>

                <!-- TikTok (stored in linkedin column) -->
                <div v-if="company.linkedin" class="social-icon-item" @click="openSocialLink(company.linkedin, 'tiktok')">
                  <div class="social-icon-circle" style="background: #000000;">
                    <i class="fab fa-tiktok" style="color: #FFFFFF; font-size: 30px;"></i>
                  </div>
                </div>

                <!-- Instagram -->
                <div v-if="company.instagram" class="social-icon-item" @click="openSocialLink(company.instagram, 'instagram')">
                  <div class="social-icon-circle" style="background: #E4405F;">
                    <i class="fab fa-instagram" style="color: #FFFFFF; font-size: 30px;"></i>
                  </div>
                </div>

                <!-- Facebook -->
                <div v-if="company.facebook" class="social-icon-item" @click="openSocialLink(company.facebook, 'facebook')">
                  <div class="social-icon-circle" style="background: #1877F2;">
                    <i class="fab fa-facebook-f" style="color: #FFFFFF; font-size: 30px;"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Footer Branding Section -->
          <div class="footer-branding-section" :style="getBrandingSectionStyle()">
            <div class="branding-content">
              <!-- AutoSyncX Logo and Text -->
              <div class="brand-logo-section">
                <div class="brand-name-container">
                  <h2 class="brand-name" :style="vcard.header_color=='Light Text' ? 'color:#000000!important' : 'color:#FFFFFF!important'">AutoSyncX</h2>
                  <div class="verified-badge">
                    <i class="material-icons-round verified-icon">verified</i>
                    <span class="verified-text">Verified<br>Partner</span>
                  </div>
                </div>
                <p class="powered-by-text" :style="vcard.header_color=='Light Text' ? 'color:#666666!important' : 'color:rgba(255,255,255,0.8)!important'">Powered by TwinTalk</p>
              </div>
            </div>
          </div>

                  <v-dialog
                      v-model="overlay"
                      width="500"
                    >
                    <img v-if="company" @click="overlay = false" style="cursor: pointer;" :src="base_url_img+'vcard/'+company.user_id+'-QR.png'" width="50">


                  </v-dialog>
                  <v-dialog
                      v-model="overlay_inventory"
                      width="500"
                    >

                    <div style="margin-top: -25px;" >
                    <QueryLookingFor class="mt-5" :color="color" :ref_id="company.user_id" @closeModalQuery="overlay_inventory = false" @vehicle-viewed="handleVehicleViewed" />
                    </div>
                    </v-dialog>

                  <!-- Card Chat Popup -->
                  <CardChatPopup
                    v-model="showChatPopup"
                    :agent-id="company.user_id"
                    :agent-name="company.first_name + ' ' + company.last_name"
                    :agent-avatar="base_url_img + company.avatar"
                    :color="color"
                  />

                  <!-- Exchange Contact Modal -->
                  <v-dialog
                    v-model="showExchangeContactModal"
                    max-width="420"
                    content-class="exchange-contact-dialog"
                    transition="dialog-bottom-transition"
                  >
                    <v-card class="exchange-modal-card">
                      <div class="exchange-modal-header">
                        <div class="exchange-brand">
                          <span class="contact-text">Contact </span><span class="exchange-text">Exchange</span>
                        </div>
                        <v-btn icon small @click="showExchangeContactModal = false" class="close-btn">
                          <v-icon class="material-icons-round">close</v-icon>
                        </v-btn>
                      </div>

                      <v-card-text class="exchange-modal-content">
                        <p class="exchange-subtitle">
                          Share your contact information.<br>
                          You will get this user's contact in a follow-up email.
                        </p>

                        <v-form ref="exchangeForm" v-model="exchangeFormValid">
                          <div class="form-field">
                            <label class="field-label">Name</label>
                            <v-text-field
                              v-model="exchangeContact.name"
                              outlined
                              dense
                              placeholder="Your full name"
                              :rules="[v => !!v || 'Name is required']"
                              class="exchange-input"
                            ></v-text-field>
                          </div>

                          <div class="form-field">
                            <label class="field-label">Phone</label>
                            <v-text-field
                              v-model="exchangeContact.phone"
                              outlined
                              dense
                              placeholder="+1 (555) 123-4567"
                              :rules="[v => !!v || 'Phone is required']"
                              class="exchange-input"
                            >
                              <template v-slot:prepend-inner>
                                <span class="phone-prefix">🇺🇸 +1</span>
                              </template>
                            </v-text-field>
                          </div>

                          <div class="form-field">
                            <label class="field-label">Email</label>
                            <v-text-field
                              v-model="exchangeContact.email"
                              outlined
                              dense
                              placeholder="your@email.com"
                              :rules="[v => !!v || 'Email is required', v => /.+@.+\..+/.test(v) || 'Valid email required']"
                              class="exchange-input"
                            ></v-text-field>
                          </div>

                          <div class="form-field">
                            <label class="field-label">Note</label>
                            <v-text-field
                              v-model="exchangeContact.note"
                              outlined
                              dense
                              placeholder="Leave your meeting note..."
                              class="exchange-input"
                            ></v-text-field>
                          </div>
                        </v-form>

                        <v-btn
                          block
                          large
                          rounded
                          color="#7C3AED"
                          dark
                          class="exchange-submit-btn"
                          :loading="exchangeSubmitting"
                          @click="submitExchangeContact"
                        >
                          Exchange Contact
                        </v-btn>
                      </v-card-text>
                    </v-card>
                  </v-dialog>

                  <!-- Meeting Location Modal -->
                  <v-dialog
                    v-model="showLocationModal"
                    max-width="420"
                    content-class="location-modal-dialog"
                    transition="dialog-bottom-transition"
                    persistent
                    :overlay-opacity="0.5"
                  >
                    <v-card class="location-modal-card">
                      <div class="location-modal-header">
                        <div class="exchange-brand">
                          <span class="contact-text">Meeting </span><span class="exchange-text">Location</span>
                        </div>
                        <v-btn icon small @click="skipLocation" class="close-btn">
                          <v-icon class="material-icons-round">close</v-icon>
                        </v-btn>
                      </div>

                      <div class="location-modal-body">
                        <h2 class="location-title">Add a Meeting Location!</h2>
                        <p class="location-subtitle">
                          Press <strong>Add Meeting Location</strong> to save the location where you met.
                          We'll share the location with both parties in our follow-up email.
                        </p>

                        <v-btn
                          block
                          large
                          rounded
                          color="#7C3AED"
                          dark
                          class="location-btn"
                          :loading="gettingLocation"
                          @click="addMeetingLocation"
                        >
                          Add Meeting Location
                        </v-btn>

                        <v-btn
                          block
                          large
                          rounded
                          outlined
                          class="skip-btn mt-3"
                          :loading="exchangeSubmitting"
                          @click="skipLocation"
                        >
                          Skip
                        </v-btn>

                        <!-- Manual Location Input (shows when geolocation fails) -->
                        <div v-if="showManualLocation" class="manual-location-section mt-4">
                          <label class="field-label">Enter Location Manually</label>
                          <v-text-field
                            v-model="manualLocationInput"
                            outlined
                            dense
                            placeholder="Enter meeting location"
                            class="exchange-input"
                            id="location-autocomplete"
                          ></v-text-field>
                          <v-btn
                            block
                            rounded
                            color="#7C3AED"
                            dark
                            class="mt-2"
                            :loading="savingLocation"
                            @click="saveManualLocation"
                          >
                            Save Location
                          </v-btn>
                        </div>
                      </div>
                    </v-card>
                  </v-dialog>

                  <!-- Inventory Lead Modal -->
                  <v-dialog
                    v-model="showInventoryLeadModal"
                    max-width="420"
                    content-class="inventory-lead-dialog"
                    transition="dialog-bottom-transition"
                  >
                    <v-card class="inventory-lead-modal-card">
                      <div class="inventory-lead-modal-header">
                        <div class="exchange-brand">
                          <span class="contact-text">View </span><span class="exchange-text">Inventory</span>
                        </div>
                        <v-btn icon small @click="showInventoryLeadModal = false" class="close-btn">
                          <v-icon class="material-icons-round">close</v-icon>
                        </v-btn>
                      </div>

                      <v-card-text class="inventory-lead-modal-content">
                        <p class="inventory-lead-subtitle">
                          Please provide your information to access our inventory.<br>
                          You'll receive a pre-approval link via SMS.
                        </p>

                        <v-form ref="inventoryLeadForm" v-model="inventoryLeadFormValid">
                          <div class="form-field">
                            <label class="field-label">Full Name *</label>
                            <v-text-field
                              v-model="inventoryLead.fullName"
                              outlined
                              dense
                              placeholder="Your full name"
                              :rules="[v => !!v || 'Full name is required']"
                              class="exchange-input"
                            ></v-text-field>
                          </div>

                          <div class="form-field">
                            <label class="field-label">Email *</label>
                            <v-text-field
                              v-model="inventoryLead.email"
                              outlined
                              dense
                              placeholder="your@email.com"
                              :rules="[v => !!v || 'Email is required', v => /.+@.+\..+/.test(v) || 'Valid email required']"
                              class="exchange-input"
                            ></v-text-field>
                          </div>

                          <div class="form-field">
                            <label class="field-label">Phone *</label>
                            <v-text-field
                              v-model="inventoryLead.phone"
                              outlined
                              dense
                              placeholder="+1 (555) 123-4567"
                              :rules="[v => !!v || 'Phone is required', v => (v && v.length >= 10) || 'Valid phone required']"
                              class="exchange-input"
                            >
                              <template v-slot:prepend-inner>
                                <span class="phone-prefix">🇺🇸 +1</span>
                              </template>
                            </v-text-field>
                          </div>

                          <div class="sms-consent-section">
                            <i class="material-icons-round mr-2" style="font-size: 18px; color: #1976D2;">check_circle</i>
                            <span class="sms-consent-text">
                              By submitting, you agree to receive SMS messages including a pre-approval link.
                            </span>
                          </div>
                        </v-form>

                        <v-btn
                          block
                          large
                          rounded
                          color="#1976D2"
                          dark
                          class="inventory-submit-btn"
                          :loading="inventoryLeadSubmitting"
                          @click="submitInventoryLead"
                        >
                          <i class="material-icons-round mr-2" style="font-size: 18px;">directions_car</i>
                          Access Inventory
                        </v-btn>
                      </v-card-text>
                    </v-card>
                  </v-dialog>

    </v-main>


    <!-- Reps View-->
    <v-main class="auth-pages" v-else >
    
        <div class="footer" id="myHeader" :style="'background-color:#272727'">
          <div class="elementor-container elementor-column-gap-default" style="width: 100%;">
            <v-row style="margin:0px!important;">
    <v-col style="padding: 1px;">
        <div class="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-a828a20" data-id="a828a20" data-element_type="column">
    <div class="elementor-widget-wrap elementor-element-populated">
              <div class="elementor-element elementor-element-88f37c7 elementor-view-default elementor-widget elementor-widget-icon" data-id="88f37c7" data-element_type="widget" data-widget_type="icon.default">
      <div class="elementor-widget-container">
        <div class="elementor-icon-wrapper">
    <a class="elementor-icon" href="tel:6026930899">
    <i aria-hidden="true" class="fa fa-id-card" :style=" 'color:white!important'"></i>			</a>
    </div>
      </div>
      </div>
      <div class="elementor-element elementor-element-f383dda elementor-widget elementor-widget-heading" data-id="f383dda" data-element_type="widget" data-widget_type="heading.default">
      <div class="elementor-widget-container">
    <h6 class="elementor-heading-title-card elementor-size-default" ><a href="tel:6026930899" :style=" 'color:white!important'">Card</a></h6>		</div>
      </div>
        </div>
    </div>
    </v-col>
    <v-col style="padding: 1px;">
      <div class="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-1eed04c" data-id="1eed04c" data-element_type="column" id="share-my-card" @click.stop="overlay = !overlay" style="position: relative; z-index: 210;">
    <div class="elementor-widget-wrap elementor-element-populated">
              <div class="elementor-element elementor-element-61dd731 elementor-view-default elementor-widget elementor-widget-icon" data-id="61dd731" data-element_type="widget" data-widget_type="icon.default">
      <div class="elementor-widget-container">
        <div class="elementor-icon-wrapper">
    <a class="elementor-icon" href="#">
    <i aria-hidden="true" class="fa fa-qrcode" :style=" 'color:white!important'"></i>			</a>
    </div>
      </div>
      </div>
      <div class="elementor-element elementor-element-08fcb6e elementor-widget elementor-widget-heading" data-id="08fcb6e" data-element_type="widget" data-widget_type="heading.default">
      <div class="elementor-widget-container">
    <h6 class="elementor-heading-title-card elementor-size-default"><a href="#" @click.stop="overlay = !overlay" :style="'color:white!important'">Scan</a></h6>		</div>
      </div>
        </div>
    </div>
    </v-col>
    <v-col style="padding: 1px;">
      <div class="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-d7c2c7a" data-id="d7c2c7a" data-element_type="column">
    <div class="elementor-widget-wrap elementor-element-populated">
              <div class="elementor-element elementor-element-5f80995 elementor-view-default elementor-widget elementor-widget-icon" data-id="5f80995" data-element_type="widget" data-widget_type="icon.default">
      <div class="elementor-widget-container">
        <div class="elementor-icon-wrapper">
    <a class="elementor-icon" :href="`tel:${company.phone_m}`">
    <i aria-hidden="true" class="fas fa-phone-alt" :style="'color:white!important'"></i>			</a>
    </div>
      </div>
      </div>
      <div class="elementor-element elementor-element-2432e95 elementor-widget elementor-widget-heading" data-id="2432e95" data-element_type="widget" data-widget_type="heading.default">
      <div class="elementor-widget-container">
    <h6 class="elementor-heading-title-card elementor-size-default"><a :href="`tel:${company.phone_m}`" :style="vcard.header_color=='Light Text' ? 'color:black!important' : 'color:white!important'">Direct Call</a></h6>		</div>
      </div>
        </div>
    </div>
    </v-col>
    <v-col v-if="event_value">
      <div class="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-5b2a404" data-id="5b2a404" data-element_type="column">
    <div class="elementor-widget-wrap elementor-element-populated">
              <div class="elementor-element elementor-element-57f7405 elementor-view-default elementor-widget elementor-widget-icon" data-id="57f7405" data-element_type="widget" data-widget_type="icon.default">
      <div class="elementor-widget-container">
        <div class="elementor-icon-wrapper">
    <a class="elementor-icon" :href="event_value" target="_blank">
    <i aria-hidden="true" class="fas fa-calendar-check"></i>			</a>
    </div>
      </div>
      </div>
      <div class="elementor-element elementor-element-eb196fc elementor-widget elementor-widget-heading" data-id="eb196fc" data-element_type="widget" data-widget_type="heading.default">
      <div class="elementor-widget-container">
    <h6 class="elementor-heading-title-card elementor-size-default"><a :href="event_value" target="_blank">Events</a></h6>		</div>
      </div>
        </div>
    </div>
    </v-col>
    </v-row>
            </div>
        </div>
        <section class="elementor-section elementor-top-section elementor-element elementor-element-a14cd74 elementor-section-height-min-height elementor-section-content-middle elementor-section-boxed elementor-section-height-default elementor-section-items-middle" data-id="a14cd74" data-element_type="section" data-settings="{&quot;background_background&quot;:&quot;video&quot;,&quot;background_video_link&quot;:&quot;https:\/\/player.vimeo.com\/video\/68384616?h=b4d1b9c66e&quot;,&quot;background_play_on_mobile&quot;:&quot;yes&quot;,&quot;shape_divider_bottom&quot;:&quot;triangle&quot;,&quot;shape_divider_bottom_negative&quot;:&quot;yes&quot;,&quot;_ha_eqh_enable&quot;:false}" :style="company.background ? 'background-image: url('+background+'); background-size: cover;  background-position: center;-repeat: no-repeat;' : ''">
              <div class="elementor-background-video-container" data-vimeo-initialized="true" v-if="company.video_background && company.video_background != 'null'">
                        <div class="elementor-background-video-embed"></div>
                    </div>
        <div class="elementor-container elementor-column-gap-default">
        <div class="elementor-column-header elementor-col-100 elementor-top-column elementor-element elementor-element-1d6f932" data-id="1d6f932" data-element_type="column">
    <div class="elementor-widget-wrap elementor-element-populated">
              <div class="elementor-element elementor-element-09cffa4 elementor-widget elementor-widget-image" data-id="09cffa4" data-element_type="widget" data-widget_type="image.default">
      <div class="elementor-widget-container">
                            <img src="@/assets/img/logo-avatar.jpg" class="attachment-full size-full wp-image-689" alt="" decoding="async" loading="lazy"  sizes="(max-width: 600px) 100vw, 600px" width="600" height="600" >															</div>
      </div>
        </div>
    </div>
            </div>
    </section>
    <v-row style="display: flex; justify-content: space-around;margin:0px!important;" >
              <v-col cols="12" style="display: flex; justify-content: space-around; margin-top: 100px; " >
                <h1 class="mb-1 text-h4 text-typo font-weight-bold"> AutoSync Representatives </h1>
                </v-col>
                <v-col cols="12" style="display: flex; justify-content: space-around" >
                  <p class="font-weight-bold text-body text-sm" style="color: black;margin-top: -15px;">Total Representatives: {{ reps_users.length }}</p>
                </v-col>
                <v-col
                      cols="12"
                      md="6"
                    >
                    
                        <v-text-field
                            color="#e91e63"
                            label="Search Representative"
                            ref="name"
                            v-model="search_rep"
                            class="font-size-input input-style"
                          >
                          </v-text-field>
                    </v-col>
              </v-row>
          <v-row style="justify-content: center;margin-bottom: 150px;margin: 0;">
            <v-col cols="12" md="12" style="">
              <ProfileCards :users="filteredUsers" />
            </v-col>
          <v-col cols="12" md="12" style="margin-bottom: 40px !important;">
            <h1 class="text-h6 mt-3 text-center">Powered by <strong>AutoSync</strong></h1>
          </v-col>
          </v-row>
          <v-row style="justify-content: center;margin-bottom:50px!important;"></v-row>

    </v-main>

    <!-- Digital Assistant Chat -->
    <!-- <DigitalAssistantChat
      v-if="currentDomain && company"
      :domain="currentDomain"
      :user-id="company.user_id"
      :user-name="company.first_name"
      :user-avatar="base_url_img + company.avatar"
      :auto-start="true"
      ref="digitalAssistant"
    /> -->

  </v-app>
</template>
<script>
var slides = document.querySelectorAll(".slide");
var currentSlide = 0;


import AppBarBlurAuth from "@/components/AppBarBlurAuth";
import VCard from 'vcard-creator'
import { FadeTransition } from "vue2-transitions";
import QueryLookingFor from "@/components/Forms/QueryLookingFor.vue";
import ProfileCards from "@/components/Forms/ProfileCards.vue";
import DigitalAssistantChat from "@/components/DigitalAssistantChat.vue";
import CardChatPopup from "@/components/CardChatPopup.vue";
export default {

  name: "page-layout",
  components: {
    AppBarBlurAuth,
    FadeTransition,
    ProfileCards,
    QueryLookingFor,
    DigitalAssistantChat,
    CardChatPopup
  },
  data() {
    return {
       checkbox: false,
       showpassword : false,
       email : '',
      password : '',
      sales_agent_count: 0,
      overlay_inventory : false,
      search_rep: '',
      ref_agent_count: 0,
      phone : '',
      loader : true,
      background: '',
      vimeo_account: '',
      vimeo_id : '',
      reps_flag : false,
      company_settings : '',
      reps_users : [],
      overlay : false,
      index: 0,
      showPassword : false,
      zoom_value : '',
      base64Image :'',
      avatar_mimeType: '',
      event_value :'',
      dialog: false,
      color : '',
      videos : [],
      pageFlag: 'init',
      backgroundLogo: localStorage.getItem('admin_bg'),
      currentDomain: null,
      isDark :true,
      buttonFlag   : false,
      loadingLogo : false,
      url : '',
      items: [
        ],
      company : '',
      vcard : '',
      loadingFlag : false,
      base_url_img : process.env.VUE_APP_WASBI_URL,
      pageTitle: '',
      programs: ['Beamer Club', 'Mercedes Club', 'Charger Club', 'Challenger Club'],
      selectedProgram: '',
      socialSpeedDial: false,
      fab: false,
      top: false,
      bottom: false,
      right: false,
      left: false,
      direction: 'top',
      hover: false,
      transition: 'slide-y-reverse-transition',
      // Exchange Contact Modal
      showExchangeContactModal: false,
      showLocationModal: false,
      exchangeFormValid: false,
      exchangeSubmitting: false,
      gettingLocation: false,
      showManualLocation: false,
      savingLocation: false,
      manualLocationInput: '',
      exchangeContact: {
        name: '',
        phone: '',
        email: '',
        note: ''
      },
      exchangeLeadId: null,
      googleAutocomplete: null,
      showChatPopup: false,
      // Inventory Lead Modal
      showInventoryLeadModal: false,
      inventoryLeadFormValid: false,
      inventoryLeadSubmitting: false,
      inventoryAccessGranted: false,
      inventoryLead: {
        fullName: '',
        email: '',
        phone: ''
      },
      inventoryLeadLocation: null,
      inventoryLeadCoordinates: null
    };
  },
  beforeCreate: function () {
    
},
created: function () {
      const domain = this.getSubdomain();
      this.currentDomain = domain;
      // Save domain to localStorage for navigation back from inventory
      if (domain) {
        localStorage.setItem('card_domain', domain);
      }
      this.getSettings()
      if(domain)
        this.getCompanyInfo(domain)
      else
        this.$router.push('/login');


},
mounted : function () {
  // Register digital assistant instance globally
  if (this.$refs.digitalAssistant) {
    this.$digitalAssistant.setInstance(this.$refs.digitalAssistant);
  }

  // Listen for global vehicle tracking events
  this.$root.$on('vehicle-viewed', this.handleGlobalVehicleView);
  this.$root.$on('vehicle-detail-viewed', this.handleGlobalVehicleDetailView);
  this.$root.$on('vehicle-search', this.handleGlobalVehicleSearch);
},

beforeDestroy() {
  // Clean up event listeners
  this.$root.$off('vehicle-viewed', this.handleGlobalVehicleView);
  this.$root.$off('vehicle-detail-viewed', this.handleGlobalVehicleDetailView);
  this.$root.$off('vehicle-search', this.handleGlobalVehicleSearch);
},
methods: {
  getPreferredRoleDescription() {
    if (this.company && this.company.roles && this.company.roles.length > 0) {
      // Priority order: referring_rep, sales_rep, then others (skip admin)
      const priorityRoles = ['referring_rep', 'sales_rep'];
      for (const roleName of priorityRoles) {
        const role = this.company.roles.find(r => r.name === roleName);
        if (role) {
          return role.description;
        }
      }
      // If no priority role found, return first non-admin role
      const nonAdminRole = this.company.roles.find(r => r.name !== 'super_admin' && r.name !== 'company_admin');
      if (nonAdminRole) {
        return nonAdminRole.description;
      }
      // Fallback to first role
      return this.company.roles[0].description;
    }
    return '';
  },
  isReferringRep() {
    if (this.company && this.company.roles && this.company.roles.length > 0) {
      return this.company.roles.some(r => r.name === 'referring_rep');
    }
    return false;
  },
  becomeAgent(agentType) {
    // Navigate to form-ref page with user_id and agent_type parameter
    this.$router.push({
      path: '/form-ref/' + this.company.user_id,
      query: { agent_type: agentType }
    });
  },
  selectProgram(program) {
    this.selectedProgram = program;
    // Navigate to beamer-club-referral page with tracking ID
    this.$router.push({
      path: '/beamer-club-referral/' + this.company.user_id,
      query: { program: program }
    });
  },
  getExchangeButtonStyle() {
    const color = this.vcard?.header_color === 'Light Text' ? '#000000' : '#FFFFFF';
    return {
      borderColor: color,
      color: color,
      backgroundColor: 'transparent'
    };
  },
  async submitExchangeContact() {
    if (!this.$refs.exchangeForm.validate()) {
      return;
    }
    // Store contact data and show location modal
    this.showExchangeContactModal = false;
    this.showLocationModal = true;
  },
  async addMeetingLocation() {
    this.gettingLocation = true;

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;

          // Reverse geocode to get address
          try {
            const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${process.env.VUE_APP_GOOGLE_API_KEY}`;
            const geocodeResponse = await axios.get(geocodeUrl);

            let locationAddress = `${latitude}, ${longitude}`;
            if (geocodeResponse.data.results && geocodeResponse.data.results.length > 0) {
              locationAddress = geocodeResponse.data.results[0].formatted_address;
            }

            await this.submitContactWithLocation(locationAddress, { latitude, longitude });
          } catch (error) {
            console.error('Error getting address:', error);
            await this.submitContactWithLocation(`${latitude}, ${longitude}`, { latitude, longitude });
          }
        },
        (error) => {
          console.error('Geolocation error:', error);
          this.gettingLocation = false;
          this.showManualLocation = true;
          this.initGoogleAutocomplete();
        },
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
      );
    } else {
      this.gettingLocation = false;
      this.showManualLocation = true;
      this.initGoogleAutocomplete();
    }
  },
  initGoogleAutocomplete() {
    this.$nextTick(() => {
      const input = document.getElementById('location-autocomplete');
      if (input && window.google && window.google.maps) {
        this.googleAutocomplete = new window.google.maps.places.Autocomplete(input, {
          types: ['geocode', 'establishment']
        });

        this.googleAutocomplete.addListener('place_changed', () => {
          const place = this.googleAutocomplete.getPlace();
          if (place.formatted_address) {
            this.manualLocationInput = place.formatted_address;
          }
        });
      }
    });
  },
  async saveManualLocation() {
    if (!this.manualLocationInput) {
      Vue.$toast.warning('Please enter a location', { position: 'top-right' });
      return;
    }

    this.savingLocation = true;
    await this.submitContactWithLocation(this.manualLocationInput, null);
  },
  async submitContactWithLocation(location, coordinates) {
    try {
      const response = await axios.post('/api/exchange-contact', {
        agent_user_id: this.company.user_id,
        name: this.exchangeContact.name,
        phone: this.exchangeContact.phone,
        email: this.exchangeContact.email,
        note: this.exchangeContact.note,
        meeting_location: location,
        meeting_coordinates: coordinates
      });

      this.gettingLocation = false;
      this.savingLocation = false;

      if (response.data.flag === 1) {
        this.closeAndResetExchange();
        Vue.$toast.success('Contact exchanged successfully!', { position: 'top-right' });
      } else {
        Vue.$toast.error(response.data.message || 'Failed to exchange contact', {
          position: 'top-right'
        });
      }
    } catch (error) {
      console.error('Error exchanging contact:', error);
      this.gettingLocation = false;
      this.savingLocation = false;
      Vue.$toast.error('Failed to exchange contact. Please try again.', { position: 'top-right' });
    }
  },
  async skipLocation() {
    // Submit contact without location
    this.exchangeSubmitting = true;
    try {
      const response = await axios.post('/api/exchange-contact', {
        agent_user_id: this.company.user_id,
        name: this.exchangeContact.name,
        phone: this.exchangeContact.phone,
        email: this.exchangeContact.email,
        note: this.exchangeContact.note
      });

      if (response.data.flag === 1) {
        this.closeAndResetExchange();
        Vue.$toast.success('Contact exchanged successfully!', { position: 'top-right' });
      } else {
        Vue.$toast.error(response.data.message || 'Failed to exchange contact', {
          position: 'top-right'
        });
      }
    } catch (error) {
      console.error('Error exchanging contact:', error);
      Vue.$toast.error('Failed to exchange contact. Please try again.', { position: 'top-right' });
    } finally {
      this.exchangeSubmitting = false;
    }
  },
  closeAndResetExchange() {
    this.showLocationModal = false;
    this.showExchangeContactModal = false;
    this.showManualLocation = false;
    this.manualLocationInput = '';
    this.exchangeContact = {
      name: '',
      phone: '',
      email: '',
      note: ''
    };
    this.exchangeLeadId = null;
  },
  // Inventory Lead Methods
  handleViewInventory() {
    // Check if inventory access is already granted (from localStorage)
    const inventoryAccess = localStorage.getItem('inventory_access_granted');
    if (inventoryAccess || this.inventoryAccessGranted) {
      this.goToInventory();
      return;
    }
    // Show the inventory lead form modal and get location automatically
    this.showInventoryLeadModal = true;
    this.getInventoryLeadLocation();
  },
  getInventoryLeadLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          this.inventoryLeadCoordinates = { latitude, longitude };

          // Reverse geocode to get address
          try {
            const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${process.env.VUE_APP_GOOGLE_API_KEY}`;
            const geocodeResponse = await axios.get(geocodeUrl);

            if (geocodeResponse.data.results && geocodeResponse.data.results.length > 0) {
              this.inventoryLeadLocation = geocodeResponse.data.results[0].formatted_address;
            } else {
              this.inventoryLeadLocation = `${latitude}, ${longitude}`;
            }
          } catch (error) {
            console.error('Error getting address:', error);
            this.inventoryLeadLocation = `${latitude}, ${longitude}`;
          }
        },
        (error) => {
          console.error('Geolocation error:', error);
          this.inventoryLeadLocation = null;
          this.inventoryLeadCoordinates = null;
        },
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
      );
    }
  },
  async submitInventoryLead() {
    if (!this.$refs.inventoryLeadForm.validate()) {
      return;
    }

    this.inventoryLeadSubmitting = true;

    try {
      const response = await axios.post('/api/submit-inventory-lead', {
        agent_user_id: this.company.user_id,
        full_name: this.inventoryLead.fullName,
        email: this.inventoryLead.email,
        phone: this.inventoryLead.phone,
        location: this.inventoryLeadLocation,
        coordinates: this.inventoryLeadCoordinates
      });

      if (response.data.flag === 1) {
        this.inventoryAccessGranted = true;
        // Save to localStorage so it persists after refresh
        localStorage.setItem('inventory_access_granted', 'true');
        this.showInventoryLeadModal = false;
        Vue.$toast.success(response.data.message || 'Thank you! You can now access the inventory.', {
          position: 'top-right'
        });
        // Navigate to inventory after successful submission
        this.goToInventory();
      } else {
        Vue.$toast.error(response.data.message || 'Failed to submit. Please try again.', {
          position: 'top-right'
        });
      }
    } catch (error) {
      console.error('Error submitting inventory lead:', error);
      Vue.$toast.error('Failed to submit. Please try again.', { position: 'top-right' });
    } finally {
      this.inventoryLeadSubmitting = false;
    }
  },
  goToInventory() {
    this.$router.push('/view-inventory');
  },
  closeAndResetInventoryLead() {
    this.showInventoryLeadModal = false;
    this.inventoryLead = {
      fullName: '',
      email: '',
      phone: ''
    };
    this.inventoryLeadLocation = null;
    this.inventoryLeadCoordinates = null;
  },
  prevSlide(index) {
  if(index !=0 )
    this.index = index - 1;
  else
    this.index = this.videos.length - 1;

},
setMetaTag(metaTags) {
    let headTag = document.getElementsByTagName('head')[0]
      for (const i in metaTags) {
        // First, delete the meta tags.
        let oldTag = document.querySelector(`meta[name="${metaTags[i].name}"]`)
        if (oldTag) {
          document.querySelector(`meta[name="${metaTags[i].name}"]`).remove()
        }
        // Second, insert the replacement meta tags.
        let newTag = document.createElement('meta')
        newTag.setAttribute('name', metaTags[i].name)
        newTag.setAttribute(metaTags[i].name, metaTags[i].content)
        headTag.appendChild(newTag)
      }
    },

// Handle vehicle viewed events for digital assistant tracking
handleVehicleViewed(eventData) {
  console.log('Vehicle viewed in Card.vue:', eventData);

  // Pass to digital assistant for tracking
  if (this.$refs.digitalAssistant) {
    this.$refs.digitalAssistant.trackVehicleView(
      eventData.vehicle_id,
      eventData.vehicle_data
    );
  }
},

// Handle global vehicle view events
handleGlobalVehicleView(eventData) {
  console.log('Global vehicle view:', eventData);

  if (this.$refs.digitalAssistant) {
    this.$refs.digitalAssistant.trackVehicleView(
      eventData.vehicle_id,
      eventData.vehicle_data
    );
  }
},

// Handle global vehicle detail view events
handleGlobalVehicleDetailView(eventData) {
  console.log('Global vehicle detail view:', eventData);

  if (this.$refs.digitalAssistant) {
    this.$refs.digitalAssistant.trackVehicleView(
      eventData.vehicle_id,
      eventData.vehicle_data
    );
  }
},

// Handle global vehicle search events
handleGlobalVehicleSearch(eventData) {
  console.log('Global vehicle search:', eventData);

  // Could be used to inform the AI about user search preferences
  if (this.$refs.digitalAssistant) {
    // Store search context for AI
    this.$refs.digitalAssistant.searchContext = eventData.search_params;
  }
},

nextSlide(index) {
  if(index != this.videos.length - 1 )
    this.index = index + 1
  else
    this.index = 0
},
gotopayemnt: function () {
    let self = this;
    self.$router.push('/card-payment/'+this.$route.params.id);
},
checkSocial(social){
  if(!this.company.social_flags)
    return true;
  let social_flags = JSON.parse(this.company.social_flags);
  if(social_flags[social] == 1)
    return true;
  return false;
},
getSubdomain() {
    const hostname = window.location.hostname;
    const domainParts = hostname.split('.');
    
    // Assuming the domain is of the form subdomain.example.com
    if (domainParts.length > 2) {
        return domainParts[0];
    } else {
        return null; // No subdomain
    }
}
,
 getCompanyInfo(id){
  
  axios({
          method: "POST",
           
          url: "/api/get-card",
          data: {
            id: id
          }
   
        })
          .then(async(response) => {
            if(response.data.flag == 1){
              if(id == 'reps'){
                
                this.reps_users = response.data.user;
                this.reps_flag = true;
                this.loader = false

              }else{
                this.company = response.data.user;
                this.vcard = response.data.vcard[0];
                this.sales_agent_count = response.data.sales_agents
                this.ref_agent_count = response.data.ref_agents
                // Save dealer phone to localStorage for inventory page footer
                if (this.company.phone_m) {
                  localStorage.setItem('dealer_phone', this.company.phone_m);
                }
                // this.background =   this.base_url_img+'vcard/'+this.company.background
                // this.company.items = JSON.parse(JSON.parse(this.company.items))
                if(this.company.video_background){
                  let video_back = this.company.video_background.split("/");
                  this.vimeo_id = video_back[0]
                  this.vimeo_account = video_back[1]
                }
                this.loader = false
                let url = process.env.VUE_APP_WASBI_URL.replace('/logo','');
                const{base64Image, mimeType} = await this.convertImageToBase64(this.base_url_img+this.company.avatar);
                this.base64Image = base64Image
                this.avatar_mimeType = mimeType
              }
            }else{
              this.$router.push('/login');
            }
          })

},
async copyURL() {
  console.log(window.location);
      try {
        await navigator.clipboard.writeText(window.location);
        alert('URL Copied, Now you can share the URL');
      } catch($e) {
        alert('Cannot copy');
      }
    },
checkFormSignup(){
  let flag = 1;
      if (!this.email) {
        Vue.$toast.error('Email is required', {
            position: 'top-right'
        });
        this.$refs['email'].focus()
        flag = 0;
      }
      if (!this.password && flag == 1) {
        Vue.$toast.error('Password is required', {
            position: 'top-right'
        });
        this.$refs['password'].focus()
        flag = 0;
      }

      if (flag == 1) {
        localStorage.setItem('temp_email',this.email)
        localStorage.setItem('temp_pass',this.password)
        localStorage.setItem('email_verified',0)
        if(this.company)
          this.$router.push('/signup/'+this.url)
        else
          this.$router.push('/signup')
      }
},
getStyle(flag){
  let self = this;
  let color = this.vcard.color;
  let font = this.vcard.header_color;
  let color_code = '';
  const colorArray = [
  { name: 'Orange', code: '#FD7E14' },
  { name: 'Green', code: '#28A745' },
  { name: 'Purple', code: '#6F42C1' },
  { name: 'Red', code: '#DC3545' },
  { name: 'Pink', code: '#E83E8C' },
  { name: 'Blue', code: '#007BFF' },
  { name: 'Dark Blue', code: '#0033cc' },
  { name: 'Black', code: '#000000' },
  { name: 'Silver', code: '#C0C0C0' },
  { name: 'Hot Pink', code: '#FF69B4' },
  { name: 'Flat Black', code: '#2D3436' }
];
colorArray.forEach(element => {
  if(element.name == color){
    color_code = element.code;
    self.color = color_code;
  }
});
if(flag == 'footer'){
  return 'background-color:'+color_code;
}
if(flag == 'button'){
  return color_code;
}
if(flag == 'background'){
  // Create softer, more muted gradient
  const lighterShade = this.adjustBrightness(color_code, 30);
  const darkerShade = this.adjustBrightness(color_code, -20);
  return 'background: linear-gradient(135deg, '+lighterShade+' 0%, '+color_code+' 50%, '+darkerShade+' 100%)';
}

},
getJoinButtonStyle() {
  let color = this.vcard.color;
  let color_code = '';
  const colorArray = [
    { name: 'Orange', code: '#FD7E14' },
    { name: 'Green', code: '#28A745' },
    { name: 'Purple', code: '#6F42C1' },
    { name: 'Red', code: '#DC3545' },
    { name: 'Pink', code: '#E83E8C' },
    { name: 'Blue', code: '#007BFF' },
    { name: 'Dark Blue', code: '#0033cc' },
    { name: 'Black', code: '#000000' },
    { name: 'Silver', code: '#C0C0C0' },
    { name: 'Hot Pink', code: '#FF69B4' },
    { name: 'Flat Black', code: '#2D3436' }
  ];

  colorArray.forEach(element => {
    if(element.name == color){
      color_code = element.code;
    }
  });

  // Create a darker shade for the button
  const darkerShade = this.adjustBrightness(color_code, -30);
  return `background-color: ${darkerShade} !important; border: none !important;`;
},
getActionIconStyle() {
  let color = this.vcard.color;
  let color_code = '';
  const colorArray = [
    { name: 'Orange', code: '#FD7E14' },
    { name: 'Green', code: '#28A745' },
    { name: 'Purple', code: '#6F42C1' },
    { name: 'Red', code: '#DC3545' },
    { name: 'Pink', code: '#E83E8C' },
    { name: 'Blue', code: '#007BFF' },
    { name: 'Dark Blue', code: '#0033cc' },
    { name: 'Black', code: '#000000' },
    { name: 'Silver', code: '#C0C0C0' },
    { name: 'Hot Pink', code: '#FF69B4' },
    { name: 'Flat Black', code: '#2D3436' }
  ];

  colorArray.forEach(element => {
    if(element.name == color){
      color_code = element.code;
    }
  });

  // Create a darker shade for the icons
  const darkerShade = this.adjustBrightness(color_code, -30);
  return `background-color: ${darkerShade};`;
},
adjustBrightness(color, percent) {
  // Convert hex to RGB
  const num = parseInt(color.replace("#",""), 16);
  const amt = Math.round(2.55 * percent);
  const R = (num >> 16) + amt;
  const G = (num >> 8 & 0x00FF) + amt;
  const B = (num & 0x0000FF) + amt;

  return "#" + (0x1000000 + (R<255?R<1?0:R:255)*0x10000 +
    (G<255?G<1?0:G:255)*0x100 +
    (B<255?B<1?0:B:255))
    .toString(16)
    .slice(1);
},
getBrandingSectionStyle() {
  let color = this.vcard.color;
  let color_code = '';
  const colorArray = [
    { name: 'Orange', code: '#FD7E14' },
    { name: 'Green', code: '#28A745' },
    { name: 'Purple', code: '#6F42C1' },
    { name: 'Red', code: '#DC3545' },
    { name: 'Pink', code: '#E83E8C' },
    { name: 'Blue', code: '#007BFF' },
    { name: 'Dark Blue', code: '#0033cc' },
    { name: 'Black', code: '#000000' },
    { name: 'Silver', code: '#C0C0C0' },
    { name: 'Hot Pink', code: '#FF69B4' },
    { name: 'Flat Black', code: '#2D3436' }
  ];

  colorArray.forEach(element => {
    if(element.name == color){
      color_code = element.code;
    }
  });

  // Create a darker shade for the branding section (20% darker)
  const darkerShade = this.adjustBrightness(color_code, -20);
  return `background-color: ${darkerShade};`;
},
forgotPass(){
    this.buttonFlag =true;
    this.isDark = false;
    axios({
          method: "POST",
           
          url: "/api/auth/forgot-password",
          data: {
            email: this.email,
          }
        })
          .then(response => {
                this.sendFlag = 1;
                Vue.$toast.success('Forgot Password Mail sent', {
                position: 'top-right'
                });
                this.buttonFlag =false;
                this.isDark = true;
                this.pageFlag = 'login';
          })
          .catch(err => {
            Vue.$toast.error(err, {
            position: 'top-right'
            });
          })
},
gotosignup: function () {
    let self = this;
    self.$router.push('/signup');
},gotoGoogle(){
      let self = this;
        this.$router.push('/redirect/google');
        location.reload();
  },
  gotoMs(){
      let self = this;
        this.$router.push('/redirect/microsoft');
        location.reload();
  },
  gotoYahoo(){
      let self = this;
        this.$router.push('/redirect/yahoo');
        location.reload();
  },
  callNumber(phoneNumber) {
      window.location.href = `tel:${phoneNumber}`;
    },
    sendEmail(email) {
      window.location.href = `mailto:${email}`;
    },
    gotoLinks(link){
      if(!link)
      link = '#'
      const newTab = window.open('', '_blank');
      newTab.location.href = link;
    },
    shareLink() {
      const url = window.location.origin+'/form-ref/'+this.company.user_id
      if (navigator.share) {
          navigator
            .share({
              title: "Signup to AutoSync™",
              text: "Become a Referral Agent",
              url: url
            })
            .then(() => console.log("thanks for share"))
            .catch(error => console.log("error", error));
        }
    },
    toggleSocialDial() {
      console.log('Toggle clicked, current state:', this.socialSpeedDial);
      console.log('Company data:', {
        facebook: this.company.facebook,
        instagram: this.company.instagram,
        tiktok: this.company.linkedin, // TikTok stored in linkedin column
        youtube: this.company.youtube
      });
      this.socialSpeedDial = !this.socialSpeedDial;
    },
    openSocialLink(link, platform) {
      if (!link) return;

      let fullUrl = link;

      // Check if link already has http/https protocol
      if (!link.startsWith('http://') && !link.startsWith('https://')) {
        // Add appropriate prefix based on platform
        switch(platform) {
          case 'facebook':
            fullUrl = link.includes('facebook.com') ? `https://${link}` : `https://www.facebook.com/${link}`;
            break;
          case 'instagram':
            fullUrl = link.includes('instagram.com') ? `https://${link}` : `https://www.instagram.com/${link}`;
            break;
          case 'tiktok':
            fullUrl = link.includes('tiktok.com') ? `https://${link}` : `https://www.tiktok.com/@${link}`;
            break;
          case 'youtube':
            fullUrl = link.includes('youtube.com') ? `https://${link}` : `https://www.youtube.com/${link}`;
            break;
          default:
            fullUrl = `https://${link}`;
        }
      }

      window.open(fullUrl, '_blank');
    },
    addContact() {
      const contact = {
        name: "John Doe",
        phone: "123-456-7890",
        email: "johndoe@example.com",
        address: "1234 Example St, Anytown, USA",
      };

      if ('contacts' in navigator && 'ContactsManager' in window) {
        navigator.contacts.select(
          ['name', 'email', 'tel', 'address'],
          { multiple: false }
        ).then((contacts) => {
          const newContact = new Contact({
            name: [contact.name],
            tel: [{ value: contact.phone }],
            email: [{ value: contact.email }],
            address: [{ value: contact.address }],
          });
          newContact.save();
        }).catch((error) => {
          console.error('Error adding contact:', error);
        });
      } else {
        alert(`Name: ${contact.name}\nPhone: ${contact.phone}\nEmail: ${contact.email}\nAddress: ${contact.address}`);
      }
    },
    openInGoogleMaps(address) {      
      const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(this.company_settings.business_address)}`;
      window.open(googleMapsUrl, '_blank');
    },
    gotoVideo() {
      const googleMapsUrl = this.company_settings.video_meeting_link;
      window.open(googleMapsUrl, '_blank');
    },
    getSettings() {
    let flag = 1;
    let url = process.env.VUE_APP_WASBI_URL
    var config = {headers: {'Content-Type': 'application/json','Cache-Control' : 'no-cache'}};
      axios({
          method: "POST",
          url: "/api/get-company-settings",
          headers: {'Content-Type': 'application/json','Cache-Control' : 'no-cache, no-store, must-revalidate',Authorization:"Bearer " + localStorage.getItem('token')}
        })
        .then(response => {
            let data = response.data.data;
            if(data){
              this.company_settings = data.settings
               localStorage.setItem('settings', JSON.stringify(data.settings));
               if(data.settings.backgroung_logo)
                localStorage.setItem('admin_bg', JSON.stringify(url+data.settings.backgroung_logo));
              else
                localStorage.setItem('admin_bg','');
            }


         })
          .catch(err => {
            // Vue.$toast.error(err, {
            // position: 'top-right'
            // });

           });

     },
     checkPermission(flag) {
     
      if(flag == 'sales'){
        let status = 0;
        if(this.company_settings.sales_rep_flag == 'None'){
          return false
        }
        else if(this.company_settings.sales_rep_flag == 'All'){
          return true
        }else{
          if(this.company_settings.sales_rep_accounts.length != 0){
          this.company_settings.sales_rep_accounts.forEach(val => {
            if(val == this.company.user_id){
              status = 1;
            }
            
          });
        }
          return status
        }
      }
      if(flag == 'ref'){
        let status_ref = 0;
        if(this.company_settings.ref_rep_flag == 'None'){
          return false
        }
        else if(this.company_settings.ref_rep_flag == 'All'){
          return true
        }else{
          this.company_settings.ref_rep_accounts.forEach(val => {
            if(val == this.company.user_id){
              status_ref = 1;
            }
            
          });
          return status_ref
        }
      }
     },
     checkPermissionPurchaseProgram(flag) {
        let status = 0;
        if(this.company_settings.display_purchase_program == 'None'){
          return false
        }
        else if(this.company_settings.display_purchase_program == 'All'){
          return true
        }else{
          if(this.company_settings.display_purchase_program_custom.length != 0){
          this.company_settings.display_purchase_program_custom.forEach(val => {
            if(val == this.company.user_id){
              status = 1;
            }
            
          });
        }
          return status
        }
     },
  exportToFile(card, name='contact', force=true) {
            const a = document.createElement('a');
            const file = new Blob([card], { type: 'text/vcard'});

            a.href = URL.createObjectURL(file);
            a.download = name;
            a.click();

            URL.revokeObjectURL(a.href);
  },
  viewInventory(){
    
    this.$router.push('/inventory-filter')
   
  },
  viewInventoryRental(){
    
    this.$router.push('/rental-inventory-filter')
   
  },
  getIcon(id,value){
    if(id == 'Phone'){
      this.phone = value
      return 'fa fa-phone';
    }
    if(id == 'Zoom'){
      this.zoom_value = value
      return 'fas fa-video';
    }
    if(id == 'Event'){
      this.event_value = value
      return 'fas fa-calendar-check';
    }
    if(id == 'Email')
      return 'fas fa-envelope';
    if(id == 'Whatsapp')
      return 'fab fa-whatsapp';
    if(id == 'SMS/Text')
      return 'fas fa-comments';
    if(id == 'Website')
      return 'fas fa-link';
    if(id == 'Instagram')
      return 'fab fa-instagram';
    if(id == 'Snapchat')
      return 'fab fa-snapchat';
    if(id == 'Twitter')
      return 'fab fa-twitter';
    if(id == 'Facebook')
      return 'fab fa-facebook';
    if(id == 'LinkedIN')
      return 'fab fa-linkedin';
    else
      return 'fas fa-link';
  },
      // Function to convert image URL to Base64
  async convertImageToBase64(imageUrl) {
    let self = this;
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    const mimeType = blob.type; // Get the MIME type of the image
    // this.avatar_mimeType = mimeType;
    // this.base64Image = blob
    // const reader = new FileReader();
    //     reader.onloadend = () => { self.base64Image = reader.result.split(',')[1]; self.avatar_mimeType = mimeType }; // Get Base64 string without the prefix
    //     reader.onerror = reject;
    //     reader.readAsDataURL(blob);
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve({ base64Image: reader.result.split(',')[1], mimeType }); // Get Base64 string without the prefix
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
},
/**
 * checkForm
 * login the user with valid email/pass
 */
async addCard(value) {
            const myVCard = new VCard()
            myVCard.addName(this.company.first_name+' '+this.company.last_name)
            if(this.company.business_name)
              myVCard.addCompany(this.company.business_name)
            myVCard.addEmail(this.company.email)
            myVCard.addPhoneNumber(this.company.phone_m)     
            
            // Add social media links if available
            if (this.company.facebook) {
                myVCard.addSocial(this.company.facebook, 'Facebook');
            }
            if (this.company.instagram) {
                myVCard.addSocial(this.company.instagram, 'Instagram');
            }
            if (this.company.linkedin) {
                myVCard.addSocial(this.company.linkedin, 'TikTok');
            }
            if (this.company.website) {
                myVCard.addSocial(this.company.website, 'Website');
            }
            if (this.company.youtube) {
                myVCard.addSocial(this.company.youtube, 'YouTube');
            }
            if (this.company.avatar) {
              if (this.avatar_mimeType == 'image/png') {
                myVCard.addPhoto(`${this.base64Image}`, 'PNG');
              }
              else if (this.avatar_mimeType == 'image/jpeg') {
                myVCard.addPhoto(`${this.base64Image}`, 'JPEG');
              }
              else if (this.avatar_mimeType == 'image/gif') {
                myVCard.addPhoto(`${this.base64Image}`, 'GIF');
              }
            }
            const output = myVCard.toString()
            const preElement = document.querySelector('#output')
            const outputNode = document.createTextNode(output)
            this.exportToFile(output,'contact',true)
          
    }
  },

  computed: {
    filteredUsers() {
      const query = this.search_rep.toLowerCase();
      return this.reps_users.filter(user => {
        const fullName = `${user.first_name} ${user.last_name}`.toLowerCase();
        return fullName.includes(query);
      });
    }
  },
  watch: {
    pageTitle() {
      this.$meta().refresh();
    },
  },
    
};
</script>
<style>
/* Modern Card Layout Styles */
.modern-card-layout {
  min-height: 100vh;
  padding-bottom: 0px;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-x: hidden;
}

.modern-card-layout::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at 30% 20%, rgba(255, 255, 255, 0.3) 0%, transparent 50%),
              radial-gradient(circle at 70% 80%, rgba(255, 255, 255, 0.2) 0%, transparent 50%);
  pointer-events: none;
  z-index: 0;
}

/* Profile Card Section */
.profile-card-section {
  position: relative;
  padding: 40px 20px 120px;
  padding-bottom: calc(120px + env(safe-area-inset-bottom, 0px));
  text-align: center;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.profile-card-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg,
    rgba(255, 255, 255, 0.25) 0%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.05) 100%);
  pointer-events: none;
  z-index: -1;
}

/* Floating Action Buttons */
.floating-action-btn {
  backdrop-filter: blur(20px) saturate(180%);
  background: rgba(255, 255, 255, 0.25) !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15),
              0 2px 8px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  width: 56px !important;
  height: 56px !important;
}

.floating-action-btn:hover {
  transform: scale(1.08) translateY(-2px);
  background: rgba(255, 255, 255, 0.35) !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2),
              0 4px 12px rgba(0, 0, 0, 0.12) !important;
}

.floating-action-btn:active {
  transform: scale(1.02) translateY(-1px);
}

.floating-action-btn i {
  font-size: 26px !important;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.12));
}

/* Profile Image */
.profile-image-container {
  margin-bottom: 35px;
  position: relative;
}

.profile-image-container::before {
  content: '';
  position: absolute;
  top: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 220px;
  height: 220px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.1) 40%, transparent 70%);
  z-index: 0;
}

.profile-image-container::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.1));
  z-index: 0;
  filter: blur(20px);
}

.profile-image {
  width: 190px;
  height: 190px;
  border-radius: 50%;
  object-fit: cover;
  border: 5px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25),
              0 8px 24px rgba(0, 0, 0, 0.15),
              inset 0 1px 0 rgba(255, 255, 255, 0.5);
  position: relative;
  z-index: 1;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  background: #fff;
}

.profile-image:hover {
  transform: scale(1.08) translateY(-5px);
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.3),
              0 12px 32px rgba(0, 0, 0, 0.2),
              inset 0 1px 0 rgba(255, 255, 255, 0.6);
  border-width: 6px;
}

/* Profile Info */
.profile-info {
  margin-bottom: 40px;
}

.profile-name {
  font-size: 42px;
  font-weight: 900;
  margin-bottom: 14px;
  letter-spacing: -1.5px;
  line-height: 1.1;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.profile-title {
  font-size: 16px;
  font-weight: 600;
  opacity: 0.92;
  margin: 0;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

/* Join Program Button */
.join-program-container {
  width: 100%;
  max-width: 520px;
  padding: 0 20px;
  margin-bottom: 40px;
}

.join-program-btn {
  width: 100%;
  height: 68px !important;
  border-radius: 50px !important;
  font-size: 20px !important;
  font-weight: 700 !important;
  text-transform: none !important;
  letter-spacing: 0.3px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2),
              0 4px 12px rgba(0, 0, 0, 0.12) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative;
  overflow: hidden;
  border: none !important;
  padding: 0 32px !important;
}

.join-program-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25),
              0 6px 16px rgba(0, 0, 0, 0.15) !important;
}

.join-program-btn:active {
  transform: translateY(0px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2) !important;
}

.join-program-btn .btn-text {
  color: #FFFFFF !important;
  text-shadow: none;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  position: relative;
  z-index: 2;
}

/* Program Dropdown Styles */
.program-dropdown-list {
  border-radius: 16px !important;
  padding: 8px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15) !important;
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.98) !important;
}

.program-list-item {
  border-radius: 12px !important;
  margin: 4px 0 !important;
  transition: all 0.2s ease !important;
  cursor: pointer;
}

.program-list-item:hover {
  background: rgba(0, 123, 255, 0.1) !important;
  transform: translateX(4px);
}

.program-item-text {
  font-size: 16px !important;
  font-weight: 600 !important;
  color: #2C3E50 !important;
}

/* Exchange Contact Button */
.exchange-contact-container {
  width: 100%;
  max-width: 520px;
  padding: 0 20px;
  margin-bottom: 15px;
  margin-top: -15px;
}

/* Send Message Button */
.send-message-container {
  width: 100%;
  max-width: 520px;
  padding: 0 20px;
  margin-bottom: 15px;
}

.send-message-btn {
  width: 100%;
  height: 52px !important;
  border-radius: 50px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.3px !important;
}

/* View Inventory Button */
.view-inventory-container {
  width: 100%;
  max-width: 520px;
  padding: 0 20px;
  margin-bottom: 30px;
}

.view-inventory-btn {
  width: 100%;
  height: 52px !important;
  border-radius: 50px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.3px !important;
}

/* Inventory Lead Modal Styles */
.inventory-lead-dialog {
  margin: 0 !important;
  position: fixed !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  max-height: 90vh !important;
  border-radius: 24px 24px 0 0 !important;
}

.inventory-lead-modal-card {
  border-radius: 24px 24px 0 0 !important;
  overflow: hidden;
  max-height: calc(90vh - 75px);
  overflow-y: auto;
}

.inventory-lead-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px 10px;
  position: sticky;
  top: 0;
  background: white;
  z-index: 1;
}

.inventory-lead-modal-content {
  padding: 0 20px 30px;
}

.inventory-lead-subtitle {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 24px;
  text-align: center;
}

.inventory-submit-btn {
  margin-top: 20px !important;
  height: 52px !important;
  border-radius: 50px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  text-transform: none !important;
}

.sms-consent-section {
  display: flex;
  align-items: flex-start;
  padding: 12px;
  background: #E3F2FD;
  border-radius: 8px;
  margin-top: 8px;
}

.sms-consent-text {
  font-size: 12px;
  color: #1976D2;
  line-height: 1.5;
}

.exchange-contact-btn {
  width: 100%;
  height: 52px !important;
  border-radius: 50px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.3px !important;
  border-width: 2px !important;
  transition: all 0.3s ease !important;
}

.exchange-contact-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

/* Exchange Contact Modal Styles */
.v-dialog__content.v-dialog__content--active {
  z-index: 2000 !important;
}

.exchange-contact-dialog {
  margin: 0 !important;
  position: fixed !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  max-height: 90vh !important;
  border-radius: 24px 24px 0 0 !important;
}

.exchange-modal-card {
  border-radius: 24px 24px 0 0 !important;
  overflow: hidden;
  max-height: calc(90vh - 75px);
  overflow-y: auto;
}

.exchange-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px 10px;
  position: sticky;
  top: 0;
  background: white;
  z-index: 1;
}

.exchange-brand {
  font-size: 22px;
  font-weight: 700;
}

.contact-text {
  color: #2C3E50;
}

.exchange-text {
  color: #7C3AED;
}

/* Fix phone prefix alignment */
.exchange-input .v-input__prepend-inner {
  align-self: center !important;
  margin-top: 0 !important;
  padding-right: 0 !important;
}

.close-btn {
  background: #f5f5f5 !important;
}

.success-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(34, 197, 94, 0.1);
  color: #22C55E;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.exchange-modal-content {
  padding: 10px 24px 30px !important;
  position: relative;
  z-index: 1;
}

.exchange-subtitle {
  color: #666;
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 24px;
}

.form-field {
  margin-bottom: 16px;
}

.field-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #2C3E50;
  margin-bottom: 6px;
}

.exchange-input .v-input__slot {
  border-radius: 12px !important;
  min-height: 48px !important;
}

.phone-prefix {
  font-size: 14px;
  color: #666;
  margin-right: 8px;
}

.exchange-submit-btn {
  height: 52px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  margin-top: 10px;
}

.location-title {
  font-size: 24px;
  font-weight: 700;
  color: #2C3E50;
  margin-bottom: 12px;
}

.location-subtitle {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 24px;
}

.location-btn {
  height: 52px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  position: relative !important;
  z-index: 10 !important;
}

.skip-btn {
  height: 52px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-color: #e0e0e0 !important;
  position: relative !important;
  z-index: 10 !important;
  color: #666 !important;
}

.manual-location-section {
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  padding: 8px 12px !important;
}

/* Location Modal Styles - separate from exchange modal */
.v-dialog__content--active:has(.location-modal-dialog) {
  z-index: 3000 !important;
}

.location-modal-dialog {
  margin: 0 !important;
  position: fixed !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  max-height: 90vh !important;
  border-radius: 24px 24px 0 0 !important;
  z-index: 3001 !important;
}

.location-modal-card {
  border-radius: 24px 24px 0 0 !important;
  overflow: visible !important;
  position: relative;
  z-index: 1;
}

.location-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px 10px;
  background: white;
  position: relative;
  z-index: 2;
}

.location-modal-body {
  padding: 10px 24px 40px;
  background: white;
  position: relative;
  z-index: 2;
}

.location-modal-body .location-btn,
.location-modal-body .skip-btn {
  pointer-events: auto !important;
  cursor: pointer !important;
}

/* Google Autocomplete dropdown z-index fix */
.pac-container {
  z-index: 10000 !important;
}

/* Action Icons Row */
.action-icons-row {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-top: 0px;
  overflow: visible !important;
  position: relative;
  z-index: 100;
}

.action-icon-item {
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

.action-icon-item:hover {
  transform: translateY(-4px);
}

.action-icon-item:active {
  transform: translateY(-2px);
}

.action-icon-circle {
  width: 68px;
  height: 68px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2),
              0 4px 12px rgba(0, 0, 0, 0.12);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
  backdrop-filter: blur(20px) saturate(180%);
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.action-icon-item:hover .action-icon-circle {
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25),
              0 6px 16px rgba(0, 0, 0, 0.15);
  transform: scale(1.08);
  border-color: rgba(255, 255, 255, 0.4);
}

.action-icon-item:active .action-icon-circle {
  transform: scale(1.02);
}

.action-icon-circle i {
  font-size: 30px;
  color: #FFFFFF;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.15));
}

/* Social Speed Dial Overlay */
.social-speed-dial-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.social-buttons-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.social-icon-item {
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.social-icon-item:hover {
  transform: scale(1.1);
}

.social-icon-item:active {
  transform: scale(0.95);
}

.social-icon-circle {
  width: 68px;
  height: 68px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3),
              0 4px 12px rgba(0, 0, 0, 0.2);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.social-icon-item:hover .social-icon-circle {
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4),
              0 6px 16px rgba(0, 0, 0, 0.25);
  transform: scale(1.05);
  border-color: rgba(255, 255, 255, 0.5);
}

.social-icon-circle i {
  font-size: 30px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.v-speed-dial .v-btn--fab.v-size--small {
  width: 50px !important;
  height: 50px !important;
  margin: 8px 0 !important;
}

/* Footer Branding Section */
.footer-branding-section {
  position: fixed;
  bottom: 70px;
  left: 0;
  right: 0;
  padding: 24px 20px 24px;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(30px) saturate(180%);
  background: linear-gradient(180deg,
    rgba(255, 255, 255, 0.15) 0%,
    rgba(255, 255, 255, 0.1) 100%);
  box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.12),
              0 -2px 8px rgba(0, 0, 0, 0.08),
              inset 0 1px 0 rgba(255, 255, 255, 0.3);
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.branding-content {
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
}

.brand-logo-section {
  margin-bottom: 20px;
}

.brand-name-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.brand-name {
  font-size: 46px;
  font-weight: 900;
  margin: 0;
  letter-spacing: -1.5px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.verified-badge {
  display: flex;
  align-items: center;
  gap: 7px;
  background: linear-gradient(135deg, #FFFFFF 0%, #F8F9FA 100%);
  padding: 9px 16px;
  border-radius: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12),
              0 2px 6px rgba(0, 0, 0, 0.08);
  border: 2px solid rgba(76, 175, 80, 0.2);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.verified-badge:hover {
  transform: scale(1.05) translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15),
              0 3px 8px rgba(0, 0, 0, 0.1);
  border-color: rgba(76, 175, 80, 0.3);
}

.verified-icon {
  color: #4CAF50;
  font-size: 22px;
  filter: drop-shadow(0 1px 2px rgba(76, 175, 80, 0.2));
}

.verified-text {
  font-size: 11px;
  font-weight: 700;
  color: #2C3E50;
  line-height: 1.3;
  text-align: left;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.powered-by-text {
  font-size: 15px;
  color: #6c757d;
  margin: 0;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  letter-spacing: 0.3px;
}

/* Fixed Bottom Footer Navigation */
.footer-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 75px;
  z-index: 1000;
  box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.15),
              0 -2px 8px rgba(0, 0, 0, 0.1),
              inset 0 1px 0 rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(30px) saturate(180%);
  background: linear-gradient(180deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.05) 100%);
  border-top: 1px solid rgba(255, 255, 255, 0.15);
}

.footer-nav-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 0 12px;
}

.footer-nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 12px 16px;
  border-radius: 20px;
  min-width: 80px;
  position: relative;
}

.footer-nav-item:hover {
  transform: translateY(-3px);
  background: rgba(255, 255, 255, 0.12);
}

.footer-nav-item:active {
  transform: translateY(-1px);
}

.footer-icon {
  font-size: 28px;
  margin-bottom: 5px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.12));
}

.footer-nav-item:hover .footer-icon {
  transform: scale(1.1);
}

.footer-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  position: relative;
  z-index: 1;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}


/* Mobile Responsive Styles */
@media (max-width: 768px) {
  .modern-card-layout {
    padding-bottom: 0px;
  }

  .profile-card-section {
    padding: 30px 15px 120px;
    padding-bottom: calc(120px + env(safe-area-inset-bottom, 0px));
    min-height: calc(100vh - 135px);
  }

  .profile-image-container::before {
    width: 170px;
    height: 170px;
  }

  .profile-image-container::after {
    width: 155px;
    height: 155px;
  }

  .profile-image {
    width: 150px;
    height: 150px;
    border-width: 4px;
  }

  .profile-image-container {
    margin-bottom: 25px;
  }

  .profile-info {
    margin-bottom: 30px;
  }

  .profile-name {
    font-size: 32px;
    margin-bottom: 10px;
    letter-spacing: -1px;
  }

  .profile-title {
    font-size: 14px;
    letter-spacing: 1px;
  }

  .join-program-container {
    margin-bottom: 30px;
  }

  .join-program-btn {
    height: 56px !important;
    font-size: 17px !important;
  }

  .action-icon-circle {
    width: 56px;
    height: 56px;
  }

  .action-icon-circle i {
    font-size: 24px;
  }

  .action-icons-row {
    gap: 30px;
    margin-top: 0px;
  }

  .brand-name {
    font-size: 34px;
    letter-spacing: -1px;
  }

  .verified-badge {
    padding: 7px 12px;
  }

  .verified-icon {
    font-size: 19px;
  }

  .verified-text {
    font-size: 10px;
  }

  .powered-by-text {
    font-size: 14px;
  }

  .footer-branding-section {
    padding: 20px 15px 0px;
    bottom: 65px;
  }

  .brand-name-container {
    margin-bottom: 8px;
    gap: 10px;
  }

  .footer-nav {
    height: 65px;
  }

  .footer-icon {
    font-size: 24px;
  }

  .footer-label {
    font-size: 9px;
  }

  .footer-nav-item {
    min-width: 65px;
    padding: 8px 10px;
  }

  .floating-action-btn {
    width: 48px !important;
    height: 48px !important;
  }

  .floating-action-btn i {
    font-size: 22px !important;
  }
}

@media (max-width: 480px) {
  .modern-card-layout {
    padding-bottom: 0px;
  }

  /* Exchange modal mobile styles */
  .exchange-modal-content {
    padding: 5px 20px 20px !important;
  }

  .exchange-subtitle {
    margin-bottom: 12px !important;
    font-size: 13px !important;
  }

  .form-field {
    margin-bottom: 8px !important;
  }

  .field-label {
    margin-bottom: 4px !important;
    font-size: 12px !important;
  }

  .exchange-input .v-input__slot {
    min-height: 42px !important;
  }

  .exchange-submit-btn {
    height: 46px !important;
    margin-top: 6px !important;
  }

  .exchange-modal-header {
    padding: 14px 16px 8px !important;
  }

  .profile-card-section {
    padding: 25px 12px 120px;
    padding-bottom: calc(120px + env(safe-area-inset-bottom, 0px));
    min-height: calc(100vh - 125px);
  }

  .profile-image-container::before {
    width: 150px;
    height: 150px;
  }

  .profile-image-container::after {
    width: 135px;
    height: 135px;
  }

  .profile-image {
    width: 130px;
    height: 130px;
    border-width: 4px;
  }

  .profile-image-container {
    margin-bottom: 22px;
  }

  .profile-info {
    margin-bottom: 28px;
  }

  .profile-name {
    font-size: 28px;
    margin-bottom: 8px;
    letter-spacing: -0.8px;
  }

  .profile-title {
    font-size: 13px;
    letter-spacing: 0.8px;
  }

  .join-program-container {
    margin-bottom: 28px;
  }

  .join-program-btn {
    height: 52px !important;
    font-size: 16px !important;
  }

  .action-icon-circle {
    width: 52px;
    height: 52px;
  }

  .action-icon-circle i {
    font-size: 22px;
  }

  .action-icons-row {
    gap: 26px;
    margin-top: 0px;
  }

  .brand-name {
    font-size: 30px;
    letter-spacing: -1px;
  }

  .verified-badge {
    padding: 6px 12px;
  }

  .verified-icon {
    font-size: 18px;
  }

  .verified-text {
    font-size: 9px;
  }

  .powered-by-text {
    font-size: 12px;
  }

  .footer-branding-section {
    padding: 18px 12px 0px;
    bottom: 60px;
  }

  .brand-name-container {
    gap: 10px;
    margin-bottom: 7px;
  }

  .footer-nav {
    height: 60px;
  }

  .footer-icon {
    font-size: 22px;
  }

  .footer-label {
    font-size: 9px;
  }

  .footer-nav-item {
    min-width: 55px;
    padding: 6px 8px;
  }

  .floating-action-btn {
    width: 44px !important;
    height: 44px !important;
  }

  .floating-action-btn i {
    font-size: 20px !important;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .profile-card-section {
    padding: 35px 20px 120px;
    padding-bottom: calc(120px + env(safe-area-inset-bottom, 0px));
    min-height: calc(100vh - 145px);
  }

  .profile-image-container::before {
    width: 200px;
    height: 200px;
  }

  .profile-image-container::after {
    width: 180px;
    height: 180px;
  }

  .profile-image {
    width: 170px;
    height: 170px;
    border-width: 5px;
  }

  .profile-name {
    font-size: 36px;
    letter-spacing: -1.2px;
  }

  .profile-title {
    font-size: 15px;
    letter-spacing: 1.1px;
  }

  .join-program-btn {
    height: 62px !important;
    font-size: 18px !important;
  }

  .action-icon-circle {
    width: 62px;
    height: 62px;
  }

  .action-icon-circle i {
    font-size: 27px;
  }

  .brand-name {
    font-size: 38px;
    letter-spacing: -1.2px;
  }

  .footer-branding-section {
    padding: 22px 20px 0px;
    bottom: 72px;
  }

  .footer-nav {
    height: 72px;
  }

  .floating-action-btn {
    width: 52px !important;
    height: 52px !important;
  }

  .floating-action-btn i {
    font-size: 24px !important;
  }
}

/* Additional utility styles */
.v-application .text-typo {
  color: inherit !important;
}

/* Smooth scroll behavior */
html {
  scroll-behavior: smooth;
}

/* Custom scrollbar for webkit browsers */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

/* Prevent text selection on interactive elements */
.floating-action-btn,
.join-program-btn,
.action-icon-item,
.footer-nav-item,
.verified-badge {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Improve tap targets for mobile */
@media (hover: none) and (pointer: coarse) {
  .floating-action-btn,
  .action-icon-item,
  .footer-nav-item {
    -webkit-tap-highlight-color: transparent;
  }
}
</style>